module.exports = __webpack_public_path__ + "img/ln4.766e0353.jpeg";